export const getFormDataPropsHelper = (
    formData: FormData,
    fromEntries: {
        [p: string]: File | string;
    } = Object.fromEntries(formData),
) => {
    return fromEntries;
};
